import React, { useState } from "react";
import search_icn from "../../../assets/images/search.svg";
import notification_icn from "../../../assets/images/notification.svg";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Sidebar from "../Sidebar/sidebar";
import { RxHamburgerMenu } from "react-icons/rx";
import { Drawer } from "antd";
import "./header.scss";

const Header = ({ title }) => {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("left");
  const location = useLocation();
  const { id } = useParams();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/society-details");
  };

  const isSocietyDetails =
    location.pathname === "/society-details" ||
    location.pathname === "/president-details" ||
    location.pathname === "/finance" ||
    location.pathname === `/edit-details/${id}`;

  return (
    <>
      <div className="header">
        <div className="header-left">
          <div className="mobile-menu" onClick={showDrawer}>
            <RxHamburgerMenu style={{ fontSize: "35px" }} />
          </div>
          <h1>{title}</h1>
        </div>
        <div className="header-right">
          <div className="add-btn">
            {!isSocietyDetails && (
              <button className="add-society-button" onClick={handleClick}>
                <span> + Add Society</span>
              </button>
            )}
          </div>
        </div>
      </div>
      <Drawer
        placement={placement}
        closable={false}
        onClose={onClose}
        open={open}
        key={placement}
        width="50%"
      >
        <Sidebar open={open} />
      </Drawer>
    </>
  );
};

export default Header;
